import { Box, Divider, Stack, styled, Typography } from "@mui/material";

const Balloon = styled("div")({
  position: "relative",
  display: "inline-block",
  padding: "8px",
  background: "#0056A0",
  boxSizing: "border-box",
  borderRadius: "8px 8px 8px 8px",
  color: "#FFFFFF",
  whiteSpace: "nowrap",
  "&:before": {
    content: '""',
    position: "absolute",
    top: "100%",
    left: "30px",
    marginLeft: "-15px",
    border: "7px solid transparent",
    borderTop: "10px solid #0056A0",
  },
});

function NameBalloon({ children: name }: { children: string }) {
  return (
    <Balloon>
      <Stack direction="row">
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </span>
        <span style={{ whiteSpace: "nowrap" }}>さんの</span>
      </Stack>
    </Balloon>
  );
}

export interface HeaderProps {
  data: {
    name: string;
    period: [string, string];
  };
}
export default function Header({ data: { name, period } }: HeaderProps) {
  const [start, end] = period.map((d) => d.split("-").map((n) => Number(n)));
  return (
    <Stack sx={{ mt: 12, mx: 6, gap: 6 }}>
      <Stack sx={{ gap: 2 }}>
        <Box>
          <NameBalloon>{name}</NameBalloon>
        </Box>
        <Typography variant="h5" color="primary.main">
          睡眠判定と改善方法
        </Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary">
        測定期間： {start[0]}年{start[1]}月{start[2]}日 ～{" "}
        {start[0] === end[0] ? "" : `${end[0]}年`}
        {end[1]}月{end[2]}日
      </Typography>
      <Divider />
    </Stack>
  );
}
